import { AccountMembership } from "./accountMembership";

export class MembershipHandicap {
    accountMembershipId: number;
    accoutMembership: AccountMembership;
    eventType: string;

    riderOne: boolean;
    handicap: number;
    wasSet: boolean;

    error: boolean;
}


// WEBPACK FOOTER //
// ./src/model/membershipHandicap.ts